


export const deleteBusinessLocation = async (functionParameters = {}) => {

    console.log("THIS IS THE PARAMETER IN deleteBusinessLocation", functionParameters);

    const axios = (await import(/* webpackPrefetch: true */ `axios`)).default;

    let {name, stripeSubscriptionId, token, addressToken, apiEndPoint, accountType, language, preloaderClass, smetioPresentationClass, smetioPresentationId, smartbox, textClass, model, uniqueValues, titleClass, subTitleClass, paragraphClass } = functionParameters;
    
    // const { smetioPresentationId } = uniqueValues;

    // functionParameters.apiEndPoint = functionParameters.apiEndPoint.replace("/businessLocations", "");
    // functionParameters.sideMenuItems = window.currentSideMenuItems;
    // functionParameters.smetioAppUi = window.currentSmetioAppUi;

    

    const displaySmartboxWithPreloader = (await import(/* webpackPrefetch: true */ `../display/displaySmartboxWithPreloader.js`)).displaySmartboxWithPreloader;
  
    const { preloader, smetioSmartbox } = await displaySmartboxWithPreloader({title:"txt539"});

    const url = `${apiEndPoint}/profileDetails/authenticationModel/${language}`;

    const res = await axios.get(url, {}).then(async (response) => {
  
      // console.log("Here is the response from createNewBusinessLocation : ",response );
  
      let model = response.data;
  
      if (model.error) return window.smetioVisitor.showNotification({ type:"danger", body: [{ message: model.msg }] });
  
      const newVersionOfConvertModelToInputs = (await import(/* webpackPrefetch: true */ `../../classes/universal_methods/newVersionOfConvertModelToInputs.js`)).newVersionOfConvertModelToInputs;
      const setTxtV2= (await import(/* webpackPrefetch: true */ `../../classes/universal_methods/setTxtV2.js`)).setTxtV2;
    

      functionParameters.preloader = preloader;
      functionParameters.smetioSmartbox = smetioSmartbox; 
  
      let instructionSubtitleText = setTxtV2({ attributes: {}, txt:"txt540", type: "html"});
      instructionSubtitleText = `
        <div>
            ${instructionSubtitleText}
            <h5 class="smetio-h5-heading smetio-text-center">${name}</h5>
        </div>                
      `;
      
      const confirmationInput = await newVersionOfConvertModelToInputs({
        model, 
        withSubmitButton: true, 
        withFullContainerDiv: true,
        submitText: window["smetioTexts"]["txt514"],
        instructionTitle:"txt515",
        instructionSubtitle:instructionSubtitleText,
        submissionFunctionDetails: {
          functionPath: "businessLocations/confirmDeleteBusinessLocation",
          functionParameters
        }
  
      });
  
      const newPreloaderDisplay = preloader.render();

      const content = `
        ${newPreloaderDisplay}
        ${confirmationInput}
      `;
      preloader.hide();
  
      // console.log("This is the content from newVersionOfConvertModelToInputs : ", content);
  
      smetioSmartbox.updateContent(content);
  
  
  
    }).catch((error) => {
  
      console.log(error);
      return window.smetioVisitor.showNotification({type:"danger", body: [{ message: "txt423"}]});
  
    }).finally(() => {
      preloader.hide();
    });
  

};
